import React, { useEffect, useState } from 'react'
import { Container, Button } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { useSearchParams, useNavigate } from 'react-router-dom'
import ReactPaginate from 'react-paginate'
import SearchBox from '../../common/component/SearchBox'
import NewItemDialog from './component/NewItemDialog'
import ProductTable from './component/ProductTable'
import {
  getProductList,
  deleteProduct,
  setSelectedProduct,
} from '../../features/product/productSlice'
import { ColorRing } from 'react-loader-spinner'

const AdminProductPage = () => {
  const navigate = useNavigate()
  const [query] = useSearchParams()
  const dispatch = useDispatch()
  const { productList, totalPageNum, loading } = useSelector(state => state.product)
  const [showDialog, setShowDialog] = useState(false)
  const [searchQuery, setSearchQuery] = useState({
    page: query.get('page') || 1,
    name: query.get('name') || '',
  }) //검색 조건들을 저장하는 객체

  const [mode, setMode] = useState('new')

  const tableHeader = ['#', 'Sku', 'Name', 'Price', 'Stock', 'Image', 'Status', '']

  //상품리스트 가져오기 (url쿼리 맞춰서)
  useEffect(() => {
    dispatch(getProductList({ ...searchQuery }))
  }, [query])

  useEffect(() => {
    //검색어나 페이지가 바뀌면 url바꿔주기 (검색어또는 페이지가 바뀜 => url 바꿔줌=> url쿼리 읽어옴=> 이 쿼리값 맞춰서  상품리스트 가져오기)
    if (searchQuery.name === '') {
      delete searchQuery.name
    }
    const params = new URLSearchParams(searchQuery)
    const query = params.toString()
    navigate('?' + query)
  }, [searchQuery])

  const deleteItem = id => {
    //아이템 삭제하기
    dispatch(deleteProduct(id))
    handlePageClick({ selected: 0 })
  }

  const openEditForm = product => {
    //edit모드로 설정하고
    // 아이템 수정다이얼로그 열어주기
    setMode('edit')
    dispatch(setSelectedProduct(product))
    setShowDialog(true)
  }

  const handleClickNewItem = () => {
    //new 모드로 설정하고
    setMode('new')
    // 다이얼로그 열어주기
    setShowDialog(true)
  }

  const handlePageClick = ({ selected }) => {
    //  쿼리에 페이지값 바꿔주기
    setSearchQuery({ ...searchQuery, page: selected + 1 })
  }
  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <ColorRing
          visible={true}
          height='80'
          width='80'
          ariaLabel='blocks-loading'
          wrapperStyle={{}}
          wrapperClass='blocks-wrapper'
          colors={['#e15b64', '#f47e60', '#f8b26a', '#abbd81', '#849b87']}
        />
      </div>
    )
  }

  return (
    <div className='locate-center'>
      <Container>
        <div className='mt-2'>
          <SearchBox
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            placeholder='제품 이름으로 검색'
            field='name'
          />
        </div>
        <Button className='mt-2 mb-2' onClick={handleClickNewItem}>
          Add New Item +
        </Button>

        <ProductTable
          header={tableHeader}
          data={productList}
          deleteItem={deleteItem}
          openEditForm={openEditForm}
        />
        <ReactPaginate
          nextLabel='next >'
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={totalPageNum}
          forcePage={searchQuery.page - 1}
          previousLabel='< previous'
          renderOnZeroPageCount={null}
          pageClassName='page-item'
          pageLinkClassName='page-link'
          previousClassName='page-item'
          previousLinkClassName='page-link'
          nextClassName='page-item'
          nextLinkClassName='page-link'
          breakLabel='...'
          breakClassName='page-item'
          breakLinkClassName='page-link'
          containerClassName='pagination'
          activeClassName='active'
          className='display-center list-style-none'
        />
      </Container>

      <NewItemDialog
        mode={mode}
        showDialog={showDialog}
        setShowDialog={setShowDialog}
        handlePageClick={handlePageClick}
      />
    </div>
  )
}

export default AdminProductPage
